import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { protobufValueMapToJson } from 'api/protobuf/utils/protobuf-value';
import { AppSettingsResponseSchema } from '../../../../pb/responses/v1/app_settings_response_pb';
import httpApi, { goBackendApi } from '../../../hooks/api/httpApi';
import { CountryProviderShippingTypes } from '../../../models/ppoints/CountryProviderShippingTypes';
import { SenderDetailsSetting, SettingsToEcom } from '../../../models/ppoints/settings/SettingsToEcom';

const getAll = async (): Promise<SettingsToEcom> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(AppSettingsResponseSchema, '/api/v1/settings/current')
        .then((response) => protobufValueMapToJson<SettingsToEcom>(response?.settings));
};

const getDefaults = async (): Promise<SettingsToEcom> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(AppSettingsResponseSchema, '/api/v1/settings/all')
        .then((response) => protobufValueMapToJson<SettingsToEcom>(response?.settings));
};

const setSettings = async (ecomId: number, settings: SettingsToEcom) => {
    let res = await httpApi.post<SettingsToEcom>(`/api/ecom/${ecomId}/settings`, {
        settings: JSON.stringify(settings),
    });
    return res.getData();
};

// const deleteSetting = (ecomId: number, settingKey: string) => {
//     return httpApi.post(`/api/ecom/${ecomId}/settings/delete`, {
//         setting_key: settingKey,
//     });
// };

const validateSenderDetails = async (senderDetails: SenderDetailsSetting) => {
    let res = await httpApi.post<{ valid: boolean }>(`/api/settings/sender-details/validate`, {
        sender_details: senderDetails,
    });
    let data = res.getData();
    return !!data.valid;
};

const checkSenderDetailsValidityWithErrorToast = async (senderDetails: SenderDetailsSetting) => {
    if (!(await validateSenderDetails(senderDetails))) {
        // console.log('Sender details are invalid or not filled completely!');
        // TODO: add banner!!!!
        // toastUtils.error(
        //     'Sender details are invalid or not filled completely!' +
        //         ' It is necessary for MPL and GLS!' +
        //         ' Please fill the Sender Details form in Settings!'
        // );
        throw new Error(
            'Sender details are invalid or not filled completely!' +
                ' It is necessary for MPL and GLS!' +
                ' Please fill the Sender Details form in Settings!'
        );
    }
};

const saveEnabledShippingTypes = async (ecomId: number, data: CountryProviderShippingTypes) => {
    let res = await httpApi.post<{ enabled_shipping_types: CountryProviderShippingTypes }>(
        `/api/ecom/${ecomId}/settings/save-shipping-types`,
        data
    );
    let returnData = res.getData();
    return returnData;
};

export default {
    getAll,
    setSettings,
    validateSenderDetails,
    checkSenderDetailsValidityWithErrorToast,
    getDefaults,
    saveEnabledShippingTypes,
};
